require("source-map-support").install(), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Theme", [], t) : "object" == typeof exports ? exports.Theme = t() : e.Theme = t();
}(this, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/", r(r.s = 437);
  }({
    121: function _(e, t, r) {
      "use strict";

      var n = r(4),
          o = r(9);
      t.a = {
        colors: n,
        fonts: o
      };
    },
    209: function _(e, t, r) {
      "use strict";

      r.r(t);
      var n = r(121);
      t.default = n.a;
    },
    4: function _(e) {
      e.exports = JSON.parse('{"white":"#ffffff","brand":"#0d51ff","brand10":"#e6edff","brand20":"#c5d2f5","brand40":"#96b1f7","brand60":"#6992fa","brand80":"#3a71fc","brand120":"#0a40cc","brand140":"#073099","brand160":"#052066","brand180":"#021033","grey":"#475b68","grey10":"#f8f8f8","grey20":"#f0f0f0","grey40":"#bbc3ca","grey60":"#919da4","grey80":"#6c7c86","grey120":"#384853","grey140":"#2a363e","grey160":"#1c2429","grey180":"#0e1214","success":"#00ab5b","successhover":"#008848","successlight":"#66cd9d","successbackground":"#e5f6ee","warninghover":"#cc9c00","warning":"#ffc400","warninglight":"#ffdc66","warningabsence":"#ffedb2","warningbackground":"#fff9e6","alerthover":"#cc180b","alert":"#ff1e0e","alertlight":"#ff786e","alertbackground":"#ffe8e6","infohover":"#b01863","info":"#dc1e7c","infolight":"#ea78b0","infobackground":"#fbe8f2","supporthover":"#583ac3","support":"#6e49f4","supportlight":"#a892f8","supportbackground":"#f0ecfe","boxshadowmedium":"rgba(71, 91, 104, 0.1)","modaloverlay":"rgba(2, 16, 51, 0.5)","transparent":"transparent"}');
    },
    437: function _(e, t, r) {
      e.exports = r(209);
    },
    9: function _(e) {
      e.exports = JSON.parse('{"H1":{"fontFamily":"URWGeometric","fontSize":46,"lineHeight":64},"H2":{"fontFamily":"URWGeometric","fontSize":38,"lineHeight":54},"H3":{"fontFamily":"URWGeometric","fontSize":26,"lineHeight":36},"H4":{"fontFamily":"URWGeometric","fontSize":20,"lineHeight":28},"H5":{"fontFamily":"URWGeometric","fontSize":18,"lineHeight":26},"Body1":{"fontFamily":"URWGeometric","fontSize":16,"lineHeight":22},"Body2":{"fontFamily":"URWGeometric","fontSize":14,"lineHeight":20},"Body3":{"fontFamily":"URWGeometric","fontSize":12,"lineHeight":16},"Body4":{"fontFamily":"URWGeometric","fontSize":10,"lineHeight":14}}');
    }
  });
});